/**
 * Backwards-compat shim. Re-export new auth provider as `AuthProvider`/`useAuth`
 * để callsites cũ (`from '@/providers/auth-provider'`) tiếp tục hoạt động.
 *
 * New code SHOULD dùng `NewAuthProvider`/`useNewAuth` từ `@/providers/new-auth-provider`.
 */
export {
  NewAuthProvider as AuthProvider,
  useNewAuth as useAuth,
} from './new-auth-provider';
